// extracted by mini-css-extract-plugin
export default {"transactions":"styles_transactions__wz77p","header":"styles_header__-Ezwn","title":"styles_title__4Dvtl"};